import { useState } from "react";
import { useNavigate } from "react-router-dom";
import apiService from "../services/apiService";
import AuthLayout from "./AuthLayout";
import "../styles/ForgotPassword.css";

const ForgotPassword = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // ✅ NEW: store JWT token from backend
  const [token, setToken] = useState("");

  const navigate = useNavigate();

  /* ================= SEND OTP ================= */
  const handleSendOtp = async () => {
    try {
      const res = await apiService.post("/forgot-password", { email });

      // ✅ SAVE TOKEN
      setToken(res.data.token);

      alert("OTP sent to your email");
      setStep(2);
    } catch (err) {
      alert(err.response?.data?.message || "Failed to send OTP");
    }
  };

  /* ================= VERIFY OTP ================= */
  const handleVerifyOtp = async () => {
    try {
      await apiService.post("/verify-otp", {
        otp,
        token, // ✅ send token
      });

      alert("OTP verified");
      setStep(3);
    } catch (err) {
      alert(err.response?.data?.message || "Invalid OTP");
    }
  };

  /* ================= RESET PASSWORD ================= */
  const handleResetPassword = async () => {
    if (newPassword !== confirmPassword) {
      return alert("Passwords do not match");
    }

    try {
      await apiService.post("/reset-password", {
        newPassword,
        token, // ✅ send token
      });

      alert("Password reset successful");
      navigate("/");
    } catch (err) {
      alert(err.response?.data?.message || "Password reset failed");
    }
  };

  return (
    <AuthLayout>
      <div className="forgot-card">
        <img
          src={require("../assets/image.png")}
          alt="JT Attorney Alliance"
          className="forgot-logo"
          style={{ width: 180, height: "auto", objectFit: "contain" }}
        />
        <h3>Forgot Password</h3>

        {/* STEP 1: EMAIL */}
        {step === 1 && (
          <>
            <input
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <button onClick={handleSendOtp}>Send OTP</button>
          </>
        )}

        {/* STEP 2: OTP */}
        {step === 2 && (
          <>
            <input
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
            <button onClick={handleVerifyOtp}>Verify OTP</button>
          </>
        )}

        {/* STEP 3: RESET PASSWORD */}
        {step === 3 && (
          <>
            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <input
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            <button onClick={handleResetPassword}>
              Reset Password
            </button>
          </>
        )}

        <p className="back-login" onClick={() => navigate("/")}>
          ← Back to Login
        </p>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
